import {components, type DropdownIndicatorProps} from 'react-select';

import type {SelectV2} from '../Select.v2';

import CloseSvg from '../../../../assets/icons/secondary/Close.svg';
import {Icon} from '../../../Icon';

export const SelectClearIndicatorV2 = (props: SelectClearIndicatorV2.Props) => {
  const size = props.size === 'xs' ? 8 : 18;

  return (
    <components.ClearIndicator {...props}>
      <Icon color={'icon.gray'} size={size} svg={CloseSvg} />
    </components.ClearIndicator>
  );
};

export namespace SelectClearIndicatorV2 {
  export type Props = DropdownIndicatorProps<unknown, true> &
    Required<Pick<SelectV2.Props, 'size'>>;
}
